import { Controller } from "@hotwired/stimulus";

// analysis-tabs (Stimulus controller) — cf. issue #340
//
// Bloc d'onglets d'analyse du simulateur (`#analysis-nav-tabContent`). La
// visibilité de chaque onglet dépend de la fiscalité courante : le contrôleur
// généraliste `toggle` masque/affiche les `<li>` et `tab-pane` via l'attribut
// `hidden` (scope `tax_program`), mais ne re-sélectionne jamais d'onglet.
//
// Conséquence : quand l'onglet actif (ex. « Impact fiscal ») devient masqué,
// plus aucun onglet visible n'est `active` et le bloc apparaît vide.
//
// Ce contrôleur observe les changements de visibilité des onglets (sans coupler
// `toggle` à la notion d'onglet actif) et, dès qu'aucun onglet visible n'est
// actif, active automatiquement le premier onglet visible et son panneau.
export default class extends Controller {
  connect() {
    this.observer = new MutationObserver(() => this.reconcile());
    this.observer.observe(this.element, {
      attributes: true,
      attributeFilter: ["hidden"],
      subtree: true,
    });

    this.reconcile();
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  get tabLinks() {
    return Array.from(this.element.querySelectorAll(".analysis-tab"));
  }

  reconcile() {
    const visibleTabs = this.tabLinks.filter((tab) => this.isVisible(tab));
    if (visibleTabs.length === 0) return;

    const activeVisible = visibleTabs.find((tab) =>
      tab.classList.contains("active")
    );

    // Si un onglet visible est déjà actif, on le ré-active (idempotent) pour
    // nettoyer un éventuel onglet masqué resté marqué `active`. Sinon, on
    // sélectionne le premier onglet visible.
    this.activateTab(activeVisible || visibleTabs[0]);
  }

  activateTab(tab) {
    this.tabLinks.forEach((link) => {
      const pane = this.paneFor(link);
      if (link === tab) {
        link.classList.add("active");
        if (pane) pane.classList.add("show", "active");
      } else {
        link.classList.remove("active");
        if (pane) pane.classList.remove("show", "active");
      }
    });
  }

  paneFor(tab) {
    const href = tab.getAttribute("href");
    if (!href || !href.startsWith("#")) return null;
    return this.element.querySelector(href);
  }

  isVisible(tab) {
    const li = tab.closest("li");
    const host = li || tab;
    return !host.hidden;
  }
}
